import { Component, ReactNode } from 'react'

import { logFrontendError } from './Utils/logger'

interface Props {
  children: ReactNode
}

interface State {
  error?: string
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    logFrontendError('Frontend Error', { errorMessage: error?.message, path: window.location?.pathname })
  }

  render() {
    if (this.state.hasError) return <div className="ts-text-cvi-brand-brand900">An error happened. Please refresh page.</div>
    return this.props.children
  }
}

export default ErrorBoundary
